/*eslint-disable*/ export const messages = JSON.parse("{\"breadcrumbs.ariaLabel\":[\"Her er du\"]}");
//# sourceMappingURL=messages.mjs.map